/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import { BaseBlockSnapshot, BlockType, ColorBlockSnapshot } from "@vienna/common";

import { PlateSocket } from "../../plate/PlateSocket/PlateSocket";
import { ClipboardUtils } from "../../utilities/ClipboardUtils";
import { BaseBlock } from "src/classes/block/BaseBlock";
export class ColorBlock extends BaseBlock<ColorBlockSnapshot> {
  plateSocket: PlateSocket | null;

  constructor(snapshot: ColorBlockSnapshot, plateSocket: PlateSocket | null) {
    super(snapshot, plateSocket);
    this.plateSocket = plateSocket;
  }

  /* -------------------------------------------------- */
  /*                        State                       */
  /* -------------------------------------------------- */
  public changeColor(hex: string): void {
    if (!this.plateSocket) return;
    this.setState({ hex });
    this.plateSocket.saveBlockUpdate(this.snapshot, this.prevSnapshot);
  }

  /* -------------------------------------------------- */
  /*                      Actions                       */
  /* -------------------------------------------------- */
  public copyHex(): void {
    ClipboardUtils.copyTextToClipboard(this.snapshot.hex);
  }

  /* -------------------------------------------------- */
  /*                   Static Methods                   */
  /* -------------------------------------------------- */
  public static newSnapshot(baseSnapshot: BaseBlockSnapshot): ColorBlockSnapshot {
    const snapshot: ColorBlockSnapshot = {
      ...baseSnapshot,
      type: BlockType.Color,
      hex: this.getRandomHex(),
    };
    return snapshot;
  }

  private static getRandomHex(): string {
    const random = [...Array(6)].map(() => Math.floor(Math.random() * 16).toString(16)).join("");
    return `#${random}`;
  }
}
